import type { GeneratedTranslationForm } from '@/services/ws-genai/src/main/resources/rest-api';
import type { TranslationDto, TranslationForm } from '@/services/ws-translate/src/main/resources/rest-api';
import { Language } from '@/services/ws-translate/src/main/resources/rest-api';

import type { FormValues, SubmitValues } from './schema.ts';

export const getDefaultValues = (translation: TranslationDto | undefined, isClone: boolean | undefined): FormValues => ({
  namespace: translation && !isClone ? { label: translation.namespace, value: translation.namespace } : null,
  key: translation?.key ?? '',
  valueEn: translation?.valueEn ?? '',
  valueDe: translation?.valueDe ?? '',
  valueFr: translation?.valueFr ?? '',
  valueIt: translation?.valueIt ?? '',
  valueDeAt: translation?.valueDeAt ?? '',
  valueDeDe: translation?.valueDeDe ?? '',
});

export const getSubmitValues = (values: SubmitValues, pageRef: string | undefined): TranslationForm => ({
  namespace: values.namespace.value,
  key: values.key,
  valueEn: values.valueEn,
  valueDe: values.valueDe,
  valueFr: values.valueFr,
  valueIt: values.valueIt,
  // ws-translate creates a key with an empty regional German left empty, with no fallback to DE-CH
  valueDeAt: values.valueDeAt || values.valueDe,
  valueDeDe: values.valueDeDe || values.valueDe,
  pageRef,
});

export const languageToFieldName = (language: Language): keyof GeneratedTranslationForm => {
  switch (language) {
    case Language.EN:
      return 'valueEn';
    case Language.DE:
      return 'valueDe';
    case Language.FR:
      return 'valueFr';
    case Language.IT:
      return 'valueIt';
    default:
      return 'valueEn';
  }
};
